module.exports = __webpack_public_path__ + "img/feature.d2142608.png";